import Vue from "vue";
import VueRouter from "vue-router";
import Main from "@/Home";
import Application from "@/views/Application";
import BIMindex from "@/views/BIMindex";
import DetailPage from "@/views/detailPage";
import LoginPage from "@/views/login/login";
import Deployment from "@/views/Deployment";
import AddAsset from "@/components/AddAsset";
import store from "@/store/index";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "blank",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/main",
    name: "Main",
    component: Main,
    children: [
      {
        path: "/Application",
        name: "Application",
        component: Application,
        meta: {
          isShow: true,
        },
      },
      {
        path: "/Deployment",
        name: "Deployment",
        component: Deployment,
        meta: {
          isShow: true,
        },
      },
      {
        path: "/BIMindex",
        name: "BIMindex",
        component: BIMindex,
        meta: {
          isShow: true,
        },
      },
      {
        path: "/detailPage",
        name: "DetailPage",
        component: DetailPage,
        meta: {
          isShow: true,
        },
      },
      {
        path: "/addAsset",
        name: "AddAsset",
        component: AddAsset,
        meta: {
          isShow: false,
        },
      },
    ],
  },
];
const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
});
function fn1(tempArr) {
  for (let i = 0; i < tempArr.length; i += 1) {
    for (let j = i + 1; j < tempArr.length; j += 1) {
      if (tempArr[i].name === tempArr[j].name) {
        tempArr.splice(j, 1);
        j -= 1;
      }
    }
  }
  return tempArr;
}
router.beforeEach((_to, from, next) => {
  // console.log(_to, "13231");
  const to = _to;
  let crumbArr;
  if (to.name !== "Login") {
    crumbArr = store.state.crumbList;
  } else {
    crumbArr = [];
  }
  const obj = {
    fullPath: to.fullPath,
    name: to.name,
    path: to.path,
    meta: {
      title: to.name,
    },
  };
  // 过滤已有color
  if (
    to.name !== "Login" &&
    to.name !== "index" &&
    to.name !== "folderPage" &&
    to.name !== "Main" &&
    to.name !== "AddAsset"
  ) {
    crumbArr.push(obj);
  }
  // console.log(crumbArr, "13231");
  // 面包屑去重
  crumbArr = fn1(crumbArr);
  const crumb = {
    crumbList: crumbArr,
    name: to.name,
  };
  // console.log(crumbArr, "crumbArr");
  store.commit("updateCrumbList", crumb); // 更新list
  next();
});
export default router;
